import { render, staticRenderFns } from "./PhoneNumberPlacement.vue?vue&type=template&id=44819728&scoped=true"
import script from "./PhoneNumberPlacement.vue?vue&type=script&lang=js"
export * from "./PhoneNumberPlacement.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberPlacement.vue?vue&type=style&index=0&id=44819728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44819728",
  null
  
)

export default component.exports